import React, { useCallback, useEffect, useState } from "react";
import { Card, Spinner, Form, Row, Col } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonGroup } from "@themesberg/react-bootstrap";
import { postApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import CustomTable from "../../../components/CustomTable";
import SearchInput from "../../../components/SearchInput";
import { useSelector } from "react-redux";
import moment from "moment";

export default function MDABudgetPerformance() {
  const user = useSelector((state) => state.auth.user);

  const [results, setResults] = useState([]);
  const [form, setForm] = useState({
    year: moment().format("YYYY"),
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getData = useCallback(() => {
    setIsLoading(true);
    postApi("select-appoved-buget?query_type=select", {
      budget_year: form.year,
    })
      .then((res) => {
        setResults(res?.results || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [form.year]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const filtered = results.filter(
    (item) =>
      !searchTerm ||
      item.economic_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.program_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.fund_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.function_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.geo_description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalBudget = filtered.reduce(
    (total, item) => total + parseFloat(item.approve_amount || 0),
    0
  );

  const totalUtilized = filtered.reduce(
    (total, item) => total + parseFloat(item.utilized || 0),
    0
  );

  const totalBalance = totalBudget - totalUtilized;

  const years = Array.from({ length: 10 }, (_, i) => moment().format("YYYY") - i);

  const fields = [
    { value: "economic_code", title: "Code" },
    { value: "economic_description", title: "Economic Description" },
    { value: "program_code", title: "Program Code" },
    { value: "program_description", title: "Program Description" },
    { value: "fund_code", title: "Fund Code" },
    { value: "fund_description", title: "Fund Description" },
    { value: "function_code", title: "Functional Code" },
    { value: "function_description", title: "Functional Description" },
    { value: "geo_code", title: "Geo Code" },
    { value: "geo_description", title: "Geo Description" },
    {
      value: "approve_amount",
      title: "Approved Budget (₦)",
      style: { textAlign: "right" },
      component: (item) => formatNumber(item.approve_amount),
    },
    {
      value: "utilized",
      title: "Utilized Amt (₦)",
      style: { textAlign: "right" },
      component: (item) => formatNumber(item.utilized),
    },
    {
      value: "balance",
      title: "Variance (₦)",
      style: { textAlign: "right" },
      component: (item) => formatNumber(item.balance),
    },
    {
      value: "utilized_percentage",
      title: "Utilize %",
      style: { textAlign: "right" },
      component: (item) => item.utilized_percentage ?? "",
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>Budget Performance of: {user?.mda_name || "MDA"}</h4>
        </div>
        <div className="d-flex align-items-center gap-2">
          <SearchInput
            placeholder="Search by description..."
            filterText={searchTerm}
            onFilterTextChange={(e) => setSearchTerm(e.target.value)}
          />
          <ButtonGroup>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() =>
                setForm({ year: moment().format("YYYY") })
              }
            >
              <FontAwesomeIcon icon={faSync} className="me-1" /> Reset
            </Button>
          </ButtonGroup>
        </div>
      </div>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Select Year</Form.Label>
            <Form.Select name="year" value={form.year} onChange={handleChange}>
              <option>--select--</option>
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={9} className="d-flex align-items-end justify-content-end gap-4">
          <span>
            <strong>Budget:</strong> ₦{formatNumber(totalBudget)}
          </span>
          <span>
            <strong>Utilized:</strong> ₦{formatNumber(totalUtilized)}
          </span>
          <span>
            <strong>Variance:</strong> ₦{formatNumber(totalBalance)}
          </span>
        </Col>
      </Row>

      <Card
        border="light"
        className="table-wrapper table-responsive shadow-sm"
      >
        <Card.Body className="p-0">
          <CustomTable
            fields={fields}
            data={filtered}
            isLoading={isLoading}
            headBackground="orange"
          />
        </Card.Body>
      </Card>
    </>
  );
}
